/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ChangeStatusPayload,
  ChargePointResponse,
  CreatePayload,
  HTTPValidationError,
  StartScenarioPayload,
  UpdateChargePointPayload,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Cp<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name CreateClientCpClientCpidPut
   * @summary Create Client
   * @request PUT:/cp/client/{cpid}
   * @response `201` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  createClientCpClientCpidPut = (cpid: string, data: CreatePayload, params: RequestParams = {}) =>
    this.request<any, HTTPValidationError>({
      path: `/cp/client/${cpid}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name DisconnectClientCpClientCpidDelete
   * @summary Disconnect Client
   * @request DELETE:/cp/client/{cpid}
   * @response `202` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  disconnectClientCpClientCpidDelete = (cpid: string, params: RequestParams = {}) =>
    this.request<any, HTTPValidationError>({
      path: `/cp/client/${cpid}`,
      method: 'DELETE',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name UpdateChargepointCpClientCpidPatch
   * @summary Update Chargepoint
   * @request PATCH:/cp/client/{cpid}
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  updateChargepointCpClientCpidPatch = (cpid: string, data: UpdateChargePointPayload, params: RequestParams = {}) =>
    this.request<any, HTTPValidationError>({
      path: `/cp/client/${cpid}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name RestartClientCpClientCpidRestartPost
   * @summary Restart Client
   * @request POST:/cp/client/{cpid}/restart
   * @response `202` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  restartClientCpClientCpidRestartPost = (cpid: string, params: RequestParams = {}) =>
    this.request<any, HTTPValidationError>({
      path: `/cp/client/${cpid}/restart`,
      method: 'POST',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name ChangeStatusCpClientCpidStatusPost
   * @summary Change Status
   * @request POST:/cp/client/{cpid}/status
   * @response `201` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  changeStatusCpClientCpidStatusPost = (cpid: string, data: ChangeStatusPayload, params: RequestParams = {}) =>
    this.request<any, HTTPValidationError>({
      path: `/cp/client/${cpid}/status`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name BeginScenarioCpClientCpidScenarioPut
   * @summary Begin Scenario
   * @request PUT:/cp/client/{cpid}/scenario
   * @response `201` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  beginScenarioCpClientCpidScenarioPut = (cpid: string, data: StartScenarioPayload, params: RequestParams = {}) =>
    this.request<any, HTTPValidationError>({
      path: `/cp/client/${cpid}/scenario`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name EndScenarioCpClientCpidScenarioDelete
   * @summary End Scenario
   * @request DELETE:/cp/client/{cpid}/scenario
   * @response `202` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  endScenarioCpClientCpidScenarioDelete = (cpid: string, params: RequestParams = {}) =>
    this.request<any, HTTPValidationError>({
      path: `/cp/client/${cpid}/scenario`,
      method: 'DELETE',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name GetHostsCpClientHostsGet
   * @summary Get Hosts
   * @request GET:/cp/client/hosts
   * @response `200` `Record<string,string>` Successful Response
   */
  getHostsCpClientHostsGet = (params: RequestParams = {}) =>
    this.request<Record<string, string>, any>({
      path: `/cp/client/hosts`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name GetScenariosCpClientScenariosGet
   * @summary Get Scenarios
   * @request GET:/cp/client/scenarios
   * @response `200` `(string)[]` Successful Response
   */
  getScenariosCpClientScenariosGet = (params: RequestParams = {}) =>
    this.request<string[], any>({
      path: `/cp/client/scenarios`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name GetModelsCpClientModelsGet
   * @summary Get Models
   * @request GET:/cp/client/models
   * @response `200` `Record<string,string>` Successful Response
   */
  getModelsCpClientModelsGet = (params: RequestParams = {}) =>
    this.request<Record<string, string>, any>({
      path: `/cp/client/models`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name GetRunningChargepointsCpClientChargepointsGet
   * @summary Get Running Chargepoints
   * @request GET:/cp/client/chargepoints
   * @response `200` `(ChargePointResponse)[]` Successful Response
   */
  getRunningChargepointsCpClientChargepointsGet = (params: RequestParams = {}) =>
    this.request<ChargePointResponse[], any>({
      path: `/cp/client/chargepoints`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name GetChargepointCpClientChargepointCpidGet
   * @summary Get Chargepoint
   * @request GET:/cp/client/chargepoint/{cpid}
   * @response `200` `ChargePointResponse` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  getChargepointCpClientChargepointCpidGet = (cpid: string, params: RequestParams = {}) =>
    this.request<ChargePointResponse, HTTPValidationError>({
      path: `/cp/client/chargepoint/${cpid}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
}
